import { Building2, Award, Users, Globe2 } from "lucide-react";
import { CONFIG } from "../../config";

const PRESS = ["MQL5 Market", "TradingView", "Forex Factory", "FXBlue", "Myfxbook", "PropFirmMatch"];

export default function BrandAuthority() {
  return (
    <section className="relative py-16 sm:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-5">
            <span className="chip">About the team</span>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
              Built by traders, <span className="text-[color:var(--gold)]">for traders</span>.
            </h2>
            <p className="text-[color:var(--ink-dim)] mt-4 leading-relaxed text-sm sm:text-base">
              <strong className="text-white">Dhokiya's Research Analyst (OPC) Private Limited</strong> is an Indian
              SEBI-compliant research firm and trading-software company based in Surat, Gujarat. Our team of
              professional XAUUSD traders, MQL5 developers and risk-engineers spent over 18 months stress-testing
              this EA against every common prop-firm rule combination — so you don't have to.
            </p>
            <p className="text-[color:var(--ink-dim)] mt-3 leading-relaxed text-sm sm:text-base">
              We don't sell signals. We don't run "VIP groups". We build tools that respect your capital and
              the rules you have to trade inside.
            </p>
            <div className="mt-6 grid grid-cols-3 gap-3">
              <div className="panel p-4">
                <Building2 className="w-4.5 h-4.5 text-[color:var(--gold)]" />
                <div className="font-display font-black text-2xl mt-2">OPC</div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)] mt-1">India registered</div>
              </div>
              <div className="panel p-4">
                <Users className="w-4.5 h-4.5 text-[color:var(--gold)]" />
                <div className="font-display font-black text-2xl mt-2">{CONFIG.BUYERS}</div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)] mt-1">Buyers worldwide</div>
              </div>
              <div className="panel p-4">
                <Globe2 className="w-4.5 h-4.5 text-[color:var(--gold)]" />
                <div className="font-display font-black text-2xl mt-2">47+</div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)] mt-1">Countries served</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="panel p-6 sm:p-8 relative overflow-hidden">
              <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[color:var(--gold)] opacity-[0.07] blur-3xl" />
              <div className="flex items-center gap-2">
                <Award className="w-5 h-5 text-[color:var(--gold)]" />
                <div className="font-mono text-[11px] uppercase tracking-widest text-[color:var(--ink-mute)]">Featured & verified on</div>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-5">
                {PRESS.map((n) => (
                  <div key={n} className="border border-[#23232a] rounded-xl px-4 py-3 text-center">
                    <div className="font-display font-bold text-sm">{n}</div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)] mt-1">verified</div>
                  </div>
                ))}
              </div>
              <div className="divider-grad my-6" />
              <div className="flex items-center gap-4">
                <div className="flex">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <span key={s} className="text-[color:var(--gold)] text-2xl leading-none">★</span>
                  ))}
                </div>
                <div>
                  <div className="font-display font-black text-2xl">{CONFIG.RATING} / 5</div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--ink-mute)]">
                    {CONFIG.BUYERS} buyers · {CONFIG.REVIEW_COUNT}+ verified reviews
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
